// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SNYm5L {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.g2wAtl {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.o1zM0u {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.QUVStA {
  padding: var(--spacing-3) var(--spacing-2) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.beTrUT {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.beTrUT img {
  width: 100%;
  height: 100%;
}

.Wdjacl {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  flex: 1;
}

.rsXheO {
  padding: var(--spacing-3) 0 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.dEd3gy {
  min-width: 0;
  margin: 0 var(--spacing-3) var(--spacing-1-5);
}

.p6kXtV,
.rW60GO {
  padding: 0 var(--spacing-3);
}

.pDOJ6S {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
}

.uYfwRs,
.s572Ow {
  background: rgba(214, 64, 0, 0.1);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.IoMwMx {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: 0;
  margin-top: 0;
}

.xp2gAc {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: 0;
  text-align: center;
}

.XUmPNm {
  margin: var(--spacing-1);
}

.s9tw6i {
  padding: 0 var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  overflow-y: auto;
  flex: 1;
}

.gY5D12 {
  background: #fafafa;
  border-radius: 8px;
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.Mv5I7T {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-2);
  padding: var(--spacing-1) var(--spacing-1-5);
  background-color: #fee7e7;
  border: 1px solid var(--status-error);
  border-radius: 8px;
  margin-bottom: var(--spacing-3);
}

.D0bDRg {
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  margin-top: var(--spacing-0-5);
}

.nLeVIN {
  flex: 1;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.AedEEg {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: var(--spacing-0-5);
}

.FduggM {
  width: 16px;
  height: 16px;
  color: var(--text-neutral-medium);
}

.NQX0Qb {
  margin-bottom: var(--spacing-2);
}

.yFjAau {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin: 0;
}

.osO7xS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-3);
}

.Y1QS4f {
  width: var(--spacing-4);
  height: var(--spacing-4);
  background: var(--surface-primary-medium);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.XvvQbe {
  width: var(--spacing-2);
  height: var(--spacing-2);
  filter: brightness(0) invert(1);
}

.WtNcZp {
  background: none;
  border: none;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-sm);
  color: var(--text-primary-medium);
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-1);
  cursor: pointer;
  padding: 0;
  text-decoration: none;
  transition: color 0.2s ease;
}

.WtNcZp:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.WtNcZp:hover:not(:disabled) {
  text-decoration: underline;
}

.cTkA4j {
  width: 12px;
  height: 12px;
  margin-left: var(--spacing-1);
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(2742%) hue-rotate(360deg) brightness(96%)
    contrast(103%);
  transition: filter 0.2s ease;
}

.F6ooAB {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.S_DSip {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.wS3WnG {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.cVgeeq {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.KPmxqC {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.zQfBUM {
  flex: 1;
}

.zQSDJJ {
  border-top: 1px solid var(--stroke-neutral-subtle);
  padding-top: var(--spacing-2);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.IwSjiU {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
  width: 100%;
}

.dOv2tq {
  display: flex;
  flex: 1;
  gap: var(--spacing-2);
}

.RLDPlW {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.mKp6XK {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.CVeLlH {
  width: var(--spacing-1);
  height: var(--spacing-1);
  background-color: var(--text-helper);
  border-radius: 50%;
  margin: 0 var(--spacing-0-5);
}

.a98Grm {
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
}

.HCCnFP {
  color: var(--status-success);
}

.CXUJPk {
  margin-top: auto;
  padding: var(--spacing-3) 0;
}

.YPR5rR {
  width: 100%;
}

.F2mnqB [data-testid='loading-spinner'] > div:first-child {
  border: none;
}

.F2mnqB [data-testid='loading-spinner'] > div:last-child {
  border-top-color: #666666;
  border-width: 1px;
}

@media (max-width: 768px) {
  .g2wAtl {
    width: 95%;
    margin: 1rem auto;
  }

  .QUVStA {
    padding: 0.75rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/ContractedBenefitsModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,4CAA4C;EAC5C,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd;kBACgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-2) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.backButton img {\n  width: 100%;\n  height: 100%;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  flex: 1;\n}\n\n.modalBody {\n  padding: var(--spacing-3) 0 0 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.hiringFeedbackToast {\n  min-width: 0;\n  margin: 0 var(--spacing-3) var(--spacing-1-5);\n}\n\n.filtersContainer,\n.contentContainer {\n  padding: 0 var(--spacing-3);\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 400px;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n}\n\n.feedbackIconContent,\n.loadingIconContent {\n  background: rgba(214, 64, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.feedbackButton {\n  margin: var(--spacing-1);\n}\n\n.layoutWrapper {\n  padding: 0 var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  overflow-y: auto;\n  flex: 1;\n}\n\n.contractCard {\n  background: #fafafa;\n  border-radius: 8px;\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.errorAlert {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  background-color: #fee7e7;\n  border: 1px solid var(--status-error);\n  border-radius: 8px;\n  margin-bottom: var(--spacing-3);\n}\n\n.errorIcon {\n  height: 20px;\n  width: 20px;\n  flex-shrink: 0;\n  margin-top: var(--spacing-0-5);\n}\n\n.errorText {\n  flex: 1;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.errorClose {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: var(--spacing-0-5);\n}\n\n.errorCloseIcon {\n  width: 16px;\n  height: 16px;\n  color: var(--text-neutral-medium);\n}\n\n.alert {\n  margin-bottom: var(--spacing-2);\n}\n\n.introText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--spacing-3);\n}\n\n.cardIconWrapper {\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  background: var(--surface-primary-medium);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.cardMainIcon {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  filter: brightness(0) invert(1);\n}\n\n.pdfLink {\n  background: none;\n  border: none;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-sm);\n  color: var(--text-primary-medium);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  cursor: pointer;\n  padding: 0;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.pdfLink:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pdfLink:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.pdfLinkIcon {\n  width: 12px;\n  height: 12px;\n  margin-left: var(--spacing-1);\n  flex-shrink: 0;\n  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(2742%) hue-rotate(360deg) brightness(96%)\n    contrast(103%);\n  transition: filter 0.2s ease;\n}\n\n.cardBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.contractTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.productList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.productItem {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.productIcon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.productLabel {\n  flex: 1;\n}\n\n.cardFooter {\n  border-top: 1px solid var(--stroke-neutral-subtle);\n  padding-top: var(--spacing-2);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.statusLine {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n  width: 100%;\n}\n\n.statusLineContent {\n  display: flex;\n  flex: 1;\n  gap: var(--spacing-2);\n}\n\n.status {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.statusIcon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.statusIconProcessing {\n  width: var(--spacing-1);\n  height: var(--spacing-1);\n  background-color: var(--text-helper);\n  border-radius: 50%;\n  margin: 0 var(--spacing-0-5);\n}\n\n.statusText {\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n}\n\n.statusActiveText {\n  color: var(--status-success);\n}\n\n.contractNewButtonWrapper {\n  margin-top: auto;\n  padding: var(--spacing-3) 0;\n}\n\n.contractNewButton {\n  width: 100%;\n}\n\n.loadingIconProcessing :global([data-testid='loading-spinner'] > div:first-child) {\n  border: none;\n}\n\n.loadingIconProcessing :global([data-testid='loading-spinner'] > div:last-child) {\n  border-top-color: #666666;\n  border-width: 1px;\n}\n\n@media (max-width: 768px) {\n  .modalDialog {\n    width: 95%;\n    margin: 1rem auto;\n  }\n\n  .modalHeader {\n    padding: 0.75rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `SNYm5L`,
	"modalDialog": `g2wAtl`,
	"modalContent": `o1zM0u`,
	"modalHeader": `QUVStA`,
	"backButton": `beTrUT`,
	"modalTitle": `Wdjacl`,
	"modalBody": `rsXheO`,
	"hiringFeedbackToast": `dEd3gy`,
	"filtersContainer": `p6kXtV`,
	"contentContainer": `rW60GO`,
	"feedbackContainer": `pDOJ6S`,
	"feedbackIconContent": `uYfwRs`,
	"loadingIconContent": `s572Ow`,
	"feedbackTitle": `IoMwMx`,
	"feedbackText": `xp2gAc`,
	"feedbackButton": `XUmPNm`,
	"layoutWrapper": `s9tw6i`,
	"contractCard": `gY5D12`,
	"errorAlert": `Mv5I7T`,
	"errorIcon": `D0bDRg`,
	"errorText": `nLeVIN`,
	"errorClose": `AedEEg`,
	"errorCloseIcon": `FduggM`,
	"alert": `NQX0Qb`,
	"introText": `yFjAau`,
	"cardHeader": `osO7xS`,
	"cardIconWrapper": `Y1QS4f`,
	"cardMainIcon": `XvvQbe`,
	"pdfLink": `WtNcZp`,
	"pdfLinkIcon": `cTkA4j`,
	"cardBody": `F6ooAB`,
	"contractTitle": `S_DSip`,
	"productList": `wS3WnG`,
	"productItem": `cVgeeq`,
	"productIcon": `KPmxqC`,
	"productLabel": `zQfBUM`,
	"cardFooter": `zQSDJJ`,
	"statusLine": `IwSjiU`,
	"statusLineContent": `dOv2tq`,
	"status": `RLDPlW`,
	"statusIcon": `mKp6XK`,
	"statusIconProcessing": `CVeLlH`,
	"statusText": `a98Grm`,
	"statusActiveText": `HCCnFP`,
	"contractNewButtonWrapper": `CXUJPk`,
	"contractNewButton": `YPR5rR`,
	"loadingIconProcessing": `F2mnqB`
};
module.exports = ___CSS_LOADER_EXPORT___;
